var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShortCutIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11619",
    "data-name": "Group 11619",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.18,
    height: 24.133,
    viewBox: "0 0 29.18 24.133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-back",
    "data-name": "Icon ionic-ios-arrow-back",
    d: "M20.889,18.257,11.757,9.133A1.725,1.725,0,1,1,14.2,6.7L24.545,17.036a1.721,1.721,0,0,1,.05,2.378L14.207,29.824a1.725,1.725,0,0,1-2.443-2.436Z",
    transform: "translate(4.133 -6.194)",
    fill: "#393939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-back-2",
    "data-name": "Icon ionic-ios-arrow-back",
    d: "M20.889,18.257,11.757,9.133A1.725,1.725,0,1,1,14.2,6.7L24.545,17.036a1.721,1.721,0,0,1,.05,2.378L14.207,29.824a1.725,1.725,0,0,1-2.443-2.436Z",
    transform: "translate(-11.251 -6.194)",
    fill: "#0094d1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortCutIcon);
export default __webpack_public_path__ + "static/media/short-cut-icon.b40d0a0258836ef45650173fa3092785.svg";
export { ForwardRef as ReactComponent };